import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function CR90(props) {
  const { nodes, materials } = useGLTF('/CR90.glb')
  // const play = useGame((state) => state.play)
  // const toggleAnim = useGame((state) => state.toggleAnim)


  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.CR90_Windows.geometry}
        material={materials.Lights}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.CR90_Thrusters.geometry}
        material={materials.Thrusters}
      />
      <mesh 
        castShadow 
        receiveShadow 
        geometry={nodes.Lights.geometry} 
        material={materials.Lights} 
        />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.CR90_Scene.geometry}
        material={materials.TextureBake}
      />
    </group>
  )
}

useGLTF.preload('/CR90.glb')
